import React, { Component, useEffect, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { mutantURIs } from "blockchain/constants";
import Unknown from "./Unknown.png";
import './style.scss';

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;



class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );
  }
}

const Responsive = (props) => {
  
  const [nftImg, setNftImg] = useState("Unknown.png");

  useEffect(() => {
    setNftImg(props.ipfs);
  }, [props.ipfs]);

  var settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: 300,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  };
  return (
      <div className='nft'>
        <Slider {...settings}>
          <CustomSlide className='itm'>
            <div className="d-item">
              <div className="nft__item price">
                    <h5>Mutant Preview</h5>
                  <div className="nft__item_wrap">
                    <Outer>
                      <span>
                        { !nftImg? 
                          (
                            <img src={Unknown} className="lazy nft__item_preview" alt=""/>
                          ): 
                          (
                            <img src={mutantURIs[nftImg]} className="lazy nft__item_preview" alt=""/>
                          )
                        }
                      </span>
                    </Outer>
                  </div>
              </div>
            </div>
          </CustomSlide>
        </Slider>
      </div>
  );
}

export default Responsive;